import React from 'react';
import styles from './InteractiveTags.module.scss';

type Props = {
  /**
   * Optional `aria-label` to apply to the list. Typically this should
   * be handled by a headline that renders above `InteractiveTags`.
   */
  'aria-label'?: string;
  /**
   * The `InteractiveTag`s to group together.
   */
  children: React.ReactNode;
};

/**
 * <span style="color: #a81227; font-weight: bold;">⚠️ DEPRECATED: Use ActionChip or FilterChipList instead.</span>
 * @deprecated Use ActionChip or FilterChipList instead.
 */
export const InteractiveTags = (props: Props) => {
  const tags = React.Children.toArray(props.children)
    .filter(Boolean)
    .map((child, i) => {
      // Using `i` for `key` since there isn't a good alternative.
      return <li key={i}>{child}</li>;
    });
  return (
    <ul aria-label={props['aria-label']} className={styles.root} data-zds>
      {tags}
    </ul>
  );
};
